import {ModuleIconInterface} from "../module-icon.interface";

export class SvgIcon {
    [key: string]: string | ModuleIconInterface
}

export const SVGICONTHEME: SvgIcon = {
    '_exit': 'minimize-2',
    'accessibility': 'accessibility_new_rounded',
    'accessibility-rounded': 'accessibility_rounded',
    'add-700': 'add_700',
    'airline_stops': 'airline_stops',
    'allTypes': 'toustypes',
    'analytics': 'moving_rounded',
    'app_redirection': 'app_redirection',
    'app-activity-search-engine-panel__icon': 'activities_search',
    'archive': 'archiver',
    'arrow-forward-ios-rounded': 'arrow_forward_ios_rounded',
    'arrow-outward-rounded': 'arrow_outward_rounded',
    'arrow-right': 'arrow-right',
    'arrow_back': 'arrow_back',
    'arrow-drop-down-rounded-700': 'arrow_drop_down_rounded_700',
    'arrow_left': 'arrow_left',
    'arrow_left_circle_outline': 'arrow_left_circle_outline',
    'arrow_outward': 'arrow_outward',
    'arrow_right': 'arrow_right',
    'arrow_right_circle_outline': 'arrow_right_circle_outline',
    'article': 'article',
    'article-rounded-fill': 'article_rounded_fill',
    'assignation': 'assignation',
    'assignment': 'task_alt_rounded',
    'assignment_ind': 'assignment_ind',
    'bd-card__menu': 'more_horiz',
    'bookmark-added': 'bookmark_added',
    'bookmark-check-fill': 'bookmark_check_fill',
    'brand': 'brand',
    'brand_square': 'brand',
    'button-audio__icon': 'equalizer_1',
    'button-list-dialog__premium-session': 'premium_action',
    'button-list-dialog__start-session': 'arrow_forward',
    'cancel': 'cancel',
    'check': 'check',
    'check-rounded-700': 'check_rounded_700',
    'checked_button': 'check',
    'chevron-right-rounded': 'chevron_right_rounded',
    'class_add': 'add',
    'close': 'cross',
    'close-700': 'close_700',
    'close-rounded': 'close_rounded',
    'close-rounded-700': 'close_rounded_700',
    'contact': 'contact',
    'corpus': 'subscriptions_rounded_fill',
    'cross': 'cross',
    'cross_outline': 'cross_outline',
    'dashboard': 'home_rounded',
    'data_check': 'data_check',
    'delete': 'trash',
    'description': 'description',
    'document': 'document',
    'drag_indicator': 'arrow_down_circle_outline',
    'duplicate': 'duplicate',
    'duplicateAndEdit': 'duplicate',
    'duplicateIfNeededAndEdit': 'edit',
    'edit': 'edit',
    'text': 'edit_note',
    'editor-play': 'play_outline',
    'editor-button-icon': 'edit',
    'educational-resources': 'overview_key_rounded_fill',
    'equalizer_1': 'equalizer_1',
    'equalizer_2': 'equalizer_2',
    'equalizer_3': 'equalizer_3',
    'equalizer_4': 'equalizer_4',
    'event-rounded-fill': 'event_rounded_fill',
    'event-upcoming-rounded-fill': 'event_upcoming_rounded_fill',
    'expand-arrow': 'arrow_drop_down_700',
    'faq-block__expand': 'chevron_down_circle',
    'feedback': 'send_rounded',
    'file': 'corpus',
    'file_download': 'file_download',
    'file_text': 'file_text_outline',
    'fill-in-blanks': 'remplir_blancs',
    'first-time-user-experience__next': 'arrow_forward',
    'first-time-user-experience__play': 'play_circle_filled',
    'first-time-user-experience__search': 'manage_search',
    'for_further': 'crossword_rounded_fill',
    'freemium-premium-compare-access__start-premium': 'premium_action',
    'freemium-premium-reverse-trial__start-premium': 'premium_action',
    'fullscreen': 'fullscreen_rounded_700',
    'gamecode-card__menu': 'more_horiz',
    'goto': 'goto',
    'group': 'group_rounded',
    'groups-form-add': 'check',
    'help': 'help',
    'home': 'home_rounded_fill',
    'home-page__onboarding-play': 'play_circle_filled',
    'home-page__onboarding-search': 'manage_search',
    'icon-arrow-back': 'arrow_back',
    'icon_pdf': 'icon_pdf',
    'info': 'info_fill',
    'error': 'cancel',
    'image__button-fullscreen': 'fullscreen_rounded_700',
    'import': 'upload',
    'institution_add': 'add',
    'keyboard-arrow-down-rounded-full': 'keyboard_arrow_down_rounded_full',
    'lessons': 'stacks_rounded',
    'link': 'url',
    'lock': 'lock',
    'lock-rounded-fill': 'lock_rounded_fill',
    'card-actions__icon-menu-trigger': 'chevron-up',
    'markunread-mailbox-rounded-fill': 'markunread_mailbox_rounded_fill',
    'memory-back-card': 'memory',
    'menu': 'menu',
    'mindmap-card__menu': 'more_horiz',
    'movies': 'movies_outline',
    'navigation-group__corpus': 'apps_legacy',
    'navigation-group__monitoring-and-statistics': 'content_paste_search',
    'navigation-group__more': 'language',
    'navigation-group__my-learners': 'manage_accounts_fill',
    'navigation-group__other-tools': 'business_center_legacy_filled',
    'navigation-group__tools': 'business_center_legacy_filled',
    'navigation-link__assignments': 'circle_custom_fill',
    'navigation-link__autonomy-usage-lessons': 'assignment_ind_fill',
    'navigation-link__bd-list': 'circle_custom_fill',
    'navigation-link__community-usage-lessons': 'co_present_fill',
    'navigation-link__contact': 'markunread_mailbox_rounded_fill',
    'navigation-link__corpus': 'circle_custom_fill',
    'navigation-link__dictionary': 'circle_custom_fill',
    'navigation-link__external-links': 'circle_custom_fill',
    'navigation-link__game-code': 'circle_custom_fill',
    'navigation-link__gleamcode': 'circle_custom_fill',
    'navigation-link__groups-management': 'circle_custom_fill',
    'navigation-link__home': 'home_legacy_filled',
    'navigation-link__language-laboratory': 'circle_custom_fill',
    'navigation-link__learner-app': 'open_in_new',
    'navigation-link__learner-management': 'circle_custom_fill',
    'navigation-link__legal-mentions': 'policy_rounded_fill',
    'navigation-link__mindmap-list': 'circle_custom_fill',
    'navigation-link__my-corpus': 'circle_custom_fill',
    'navigation-link__notepad-list': 'circle_custom_fill',
    'navigation-link__other-collections': 'circle_custom_fill',
    'navigation-link__premium-item': 'premium_item',
    'navigation-link__progress-tracking': 'circle_custom_fill',
    'navigation-link__own_progress-tracking': 'trending_up_rounded',
    'navigation-link__user-lesson-list': 'circle_custom_fill',
    'navigation-link__work-group-management': 'circle_custom_fill',
    'navigation-link__leaner-assignments': 'content_paste_search',
    'next': 'arrow_right_alt_rounded',
    'notepad-card__menu': 'more_horiz',
    'nothing': 'scan_delete',
    'onboarding_header': 'onboarding_header',
    'open-in-new-rounded': 'open_in_new_rounded',
    'outils2': 'deployed_code_rounded_fill',
    'overview_key': 'overview_key',
    'pdf': 'pdf',
    'pdf_full_name': 'pdf_full_name',
    'play': 'arrow_right',
    'play-in-class': 'play',
    'policy-rounded-fill':'policy_rounded_fill',
    'pretty-easy-navigation__close-menu': 'arrow_back',
    'pretty-easy-navigation__logo': 'brand',
    'pretty-easy-navigation__toggle-menu': 'menu_rounded',
    'previous': 'arrow_left_alt_rounded',
    'progression__launch': 'progression__launch',
    'qcm__register__incorrect': 'false',
    'qcm__register__not-correct': 'false',
    'qcm__register__null': 'true',
    'qcm__register__pristine': 'true',
    'quit': 'reply_all_rounded',
    'recommendation': 'thumb_up_rounded',
    'restart-alt-rounded': 'restart_alt_rounded',
    'retry': 'refresh_rounded_alt',
    'return': 'arrow_return',
    'round-videoprojeter': 'round_videoprojeter',
    'round-videoprojeteroff': 'round_videoprojeteroff',
    'save': 'save',
    'shield': 'confi',
    'sound_off': 'sound_off',
    'sound_on': 'sound_on',
    'speaker-equalizer': 'speaker_equalizer',
    'step-done': 'step_done',
    'step-inprogress': 'step_inprogress',
    'step-pasfait': 'step_pasfait',
    'student_add': 'check_circle_outline',
    'toolbar__open-web-app': 'open_in_new_rounded',
    'toolbar__premium-action': 'premium_action',
    'toolbar__web-app-logo': 'web_app',
    'tools-circle': 'cube_outline_circle',
    'trainer_add': 'add',
    'transition': 'transition',
    'trash': 'trash',
    'tune-rounded': 'tune_rounded',
    'unarchive': 'desarchiver',
    'unassign': 'unassign',
    'unchecked_button': 'uncheck',
    'unlock': 'unlock',
    'upload': 'upload',
    'video': 'video',
    'visibility': 'visibility',
    'visibility_cgurgpd': 'article_rounded',
    'visibility_legalnotice': 'visibility_rounded',
    'visibility_privacy': 'lock_rounded',
    'workgroup_add': 'add',
    'xxx': 'dislike',
    'keyboard_tab_right': 'keyboard_tab_right',
    'keyboard_tab_left': 'keyboard_tab_left',
    'forward_to_inbox': 'forward_to_inbox',
    'event_upcoming': 'event_upcoming',
    'enhanced_encryption': 'enhanced_encryption',
    'close_1': 'close_1',
    'add_1': 'add_1',
    'site_map': 'site_map',
};